module.exports = __webpack_public_path__ + "img/1673802963241-GALERRY11.jpg.d68fedd0.webp";